import { GetGroupByIdResponse } from '@/modules/manage-member/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getGroupById } from '../../services'
import { OperatorQueryKeys } from '@/modules/manage-member/keys'

export default function useQueryGetGroupById(
	id: string,
	props?: UseBaseQueryOptions<GetGroupByIdResponse>,
) {
	return useQuery({
		queryKey: [OperatorQueryKeys.GetGroupById, id],
		queryFn: () => getGroupById(id),
		...props,
	})
}
